import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

// Connects to data-controller="gateway-payment"
export default class extends Controller {
  static targets = ['cardNumber', 'cvv', 'submitBtn', 'loaderModal']

  connect() {
    this.submitted = false

    if (this.hasLoaderModalTarget) {
      this.modal = new Modal(this.loaderModalTarget, {
        backdrop: 'static',
        keyboard: false,
      })
    }
  }

  handleSubmit(event) {
    if (this.submitted) return

    // Strip spaces from card number before submission
    this.stripCardNumberSpaces()

    // Validation passed — show loader and allow normal form POST
    this.submitted = true
    this.showLoader()
  }

  stripCardNumberSpaces() {
    if (this.hasCardNumberTarget) {
      this.cardNumberTarget.value = this.cardNumberTarget.value.replace(
        /\s/g,
        ''
      )
    }
  }

  formatCardNumber() {
    let value = this.cardNumberTarget.value.replace(/\D/g, '')
    value = value.substring(0, 16)
    value = value.replace(/(\d{4})(?=\d)/g, '$1 ')
    this.cardNumberTarget.value = value
  }

  formatCvv() {
    this.cvvTarget.value = this.cvvTarget.value
      .replace(/\D/g, '')
      .substring(0, 4)
  }

  showLoader() {
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.classList.add('disabled')
    }
    if (this.modal) {
      this.modal.show()
    }
  }

  disconnect() {
    if (this.modal) {
      this.modal.dispose()
    }
  }
}
